import { useSesion } from '../servicios/sesion.js';
import { TablaVersionesApp } from './plataforma/versiones-app.js';

/**
 * "Gestión" — configuración GLOBAL accesible desde el propio admin de la
 * organización, no solo desde la consola de plataforma (a pedido explícito:
 * ver memoria `forzar_actualizacion_app`).
 *
 * Ojo con esto al leer el código: a diferencia de cualquier otra página de
 * este sidebar, lo que se edita aquí NO es de esta organización — es
 * `platform.versiones_app`, compartida por TODOS los tenants. El backend
 * (`GestionController`, permiso `app_version:gestionar`, solo ADMINISTRADOR)
 * dejó ese rastro más marcado en la bitácora justamente por eso.
 */
export function Gestion(): JSX.Element {
  const { puede } = useSesion();

  return (
    <TablaVersionesApp puedeEscribir={puede('app_version:gestionar')} rutaBase="/gestion/versiones-app">
      <h1>Gestión</h1>
      <p>
        Versión mínima, aviso de versión nueva y mantenimiento de la app móvil. <strong>Afecta a todas las
        organizaciones</strong>, no solo a la tuya — es la misma configuración que ve la consola de plataforma.
      </p>
    </TablaVersionesApp>
  );
}
